import { Component } from '@angular/core';
import { InstanceService } from '@commonspirit/ngx-instance';

import { ConfigurationKey } from '../../core/models/configuration-key';

@Component({
  selector: 'fal-lite-home',
  templateUrl: './fal-lite.component.html',
  styleUrls: ['./fal-lite.component.scss']
})
export class FalLiteComponent {
  searchHomeDescription: string;
  showERInfo: boolean;
  doSVG = false;
  isLocationSelected = false;
  emergencyText: string = this.service.getConfiguration(ConfigurationKey.EmergencyText)?.value as string;

  constructor(private service: InstanceService) {
    this.searchHomeDescription =
      (this.service.getConfiguration(ConfigurationKey.SearchHomeDescription)?.value as string) ??
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dapibus lacinia felis, id maximus urna mollis eu.';

    this.showERInfo = (this.service.getConfiguration(ConfigurationKey.ShowERInfo)?.value as boolean) ?? true;
  }

  checkLocationSelected(isLocationSelected: boolean): void {
    this.isLocationSelected = isLocationSelected;
  }
}
